import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import 'react-toastify/dist/ReactToastify.css';
import './styles/styles.css';
import './index.scss';
import * as serviceWorker from './serviceWorker';
import { Providers } from 'app/providers';
import { initialize as initializeDataDog } from 'utils/datadog';
import { initialize as initializeHotjar } from 'lib/hotjar';
import { isProdEnv } from 'utils/utilities';
import { isRestrictedDomain, getAllowedHost } from 'utils/restrictedDomain';
import RestrictedDomain from 'features/common/errors/RestrictedDomain';

// Non-prod builds must not run on authenticating.com: Regula would charge their ID checks
// to the production license bound to that domain. Decided before the store, router, any
// API call or the lazy Regula flow loads. Always false on prod and localhost.
const restrictedDomain = isRestrictedDomain();

initializeDataDog();
if (!restrictedDomain) {
    initializeHotjar();
}

//Hide console log messages on production
if (isProdEnv()) {
    console.log = () => {};
}

ReactDOM.render(
    restrictedDomain ? (
        <RestrictedDomain allowedHost={getAllowedHost(window.location.hostname)} />
    ) : (
        <Providers />
    ),
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
